export const getters = {
  ID: (state: any): string => state.id,
  IS_CONTACT: (state: any) => state.isContact,
  IS_ORGANIZATION: (state: any) => state.isOrganization,
  IS_NOT_FOUND: (state: any) => state.isNotFound,
  MESSAGES: (state: any) => state.messages
}
